import React from 'react';

export const sceneSixMeta = {
  id: 'tree-dharma',
  title: '場景六｜一棵樹裡，看見佛法',
  excerpt: '從樹的四季流動，看見「應無所住，而生其心」的生命智慧。',
};

const SceneSixTreeDharma: React.FC = () => (
  <article className="forest-article-detail">
    <h2>{sceneSixMeta.title}</h2>
    <p>六祖惠能法師年少貧苦，常上山砍柴、拾木材。</p>
    <p>他長年行走山林之中，春夏秋冬、晴天雨天，都與樹木相伴。</p>
    <p>也許，真正讓他悟道的，不只是聽見《金剛經》那一句：「應無所住，而生其心。」</p>
    <p>而是他早已在森林裡，看見了這句話。</p>
    <p>森林裡的樹：</p>
    <ul>
      <li>不執著一片葉子</li>
      <li>不執著一個季節</li>
      <li>不執著一場風雨</li>
      <li>不執著一時的繁盛與枯萎</li>
    </ul>
    <p>葉子掉了，明年再長。花謝了，季節到了再開。</p>
    <p>暴風雨來了，它仍安靜站著。寒冬看似枯寂，根卻仍深深往土地延伸。</p>
    <p>它不抗拒四季，也不害怕變化。因為樹知道：生命，本來就是流動。</p>
    <p>真正強大的樹，不是永遠不掉葉子，而是即使失去，依然繼續生長；即使風吹雨打，依然向著陽光；即使沒有人稱讚，仍默默扎根。</p>
    <blockquote>這就是：「應無所住，而生其心。」</blockquote>
    <p>不把自己困在一次失敗、一句批評、一段低潮、一個身份、一時的成功。</p>
    <p>而是在變化之中，仍保有願意成長的心。</p>
    <p>森林教育想教孩子的，也許不是「一定要贏」。而是像樹一樣：</p>
    <ul>
      <li>遇風不倒</li>
      <li>遇雨不怨</li>
      <li>遇冬不怕</li>
      <li>遇挫折仍願成長</li>
    </ul>
    <p>因為真正的成熟，不是沒有痛苦，而是歷經四季後，依然願意長成一棵能替別人遮風避雨的大樹。</p>
  </article>
);

export default SceneSixTreeDharma;
